<template>
  <div>
    <el-table :data="projectList">
      <el-table-column prop="id" label="ID"> </el-table-column>
      <el-table-column prop="__type" label="类型"> </el-table-column>
      <el-table-column prop="coinType" label="币种"> </el-table-column>
      <el-table-column prop="__problem" label="问题"> </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.__status.color">
            {{ scope.row.__status.text }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="展示">
        <template slot-scope="scope">
          <el-switch
            active-color="#13ce66"
            @change="toggleEnabled(scope.row, $event)"
            :value="scope.row.enabled"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column label="开始时间">
        <template slot-scope="scope">
          <span>{{ scope.row.startTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column label="结束时间">
        <template slot-scope="scope">
          <span>{{ scope.row.endTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column label="结果">
        <template slot-scope="scope">
          <span v-if="scope.row.__result != undefined"
            >选项{{ scope.row.__result }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            circle
            icon="el-icon-edit"
            :disabled="scope.row.status !== 0"
            @click="viewDetail(scope.row)"
          ></el-button>
          <el-button
            type="primary"
            size="small"
            circle
            icon="el-icon-setting"
            :disabled="
              scope.row.status === 0 ||
                scope.row.status === 1 ||
                scope.row.status === 3 ||
                scope.row.status === 4
            "
            @click="handleResult(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange"
    >
    </pagination>
    <detail @refresh="handleCurrentChange({ page: 1 })"></detail>
    <el-dialog
      title="设置结果"
      width="650px"
      :visible.sync="resultDialogVisible"
      @close="closeResultDialog"
    >
      <div>
        结果：
        <el-select v-model="result" placeholder="请选择选项">
          <el-option
            v-for="item in resultOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resultDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleResultSave">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Pagination from 'components/pagination';
import Detail from '../detail';

export default {
  name: 'quizList',
  data() {
    return {
      resultDialogVisible: false,
      resultOptions: [],
      result: null,
      resultProject: null
    };
  },
  computed: {
    ...mapState('quiz', ['totalCount', 'pagination']),
    ...mapGetters('quiz', ['projectList'])
  },
  components: {
    Pagination,
    Detail
  },
  methods: {
    ...mapMutations('quiz', ['setEditingProject', 'setDetailDialogVisible']),
    ...mapActions('quiz', ['enable', 'disable', 'setResult']),
    viewDetail(project) {
      this.setDetailDialogVisible(true);
      this.setEditingProject(project);
    },
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    },
    toggleEnabled(project, status) {
      const action = status ? this.enable : this.disable;

      action({ id: project.id }).then(() => {
        this.$message.success('操作成功！');
        this.$emit('refresh');
      });
    },
    handleResult(project) {
      this.resultDialogVisible = true;
      this.resultProject = project;
      this.resultOptions = project.options.map(item => {
        return {
          label: item.value['1'],
          value: item.id
        };
      });
    },
    handleResultSave() {
      this.setResult({
        id: this.resultProject.id,
        result: this.result
      }).then(() => {
        this.$message.success('设置成功！');
        this.closeResultDialog();
        this.$emit('refresh');
      });
    },
    closeResultDialog() {
      this.resultDialogVisible = false;
      this.result = null;
    }
  }
};
</script>

<style lang="less" scoped>
.link-button {
  margin-left: 10px;
}
</style>
